@if (product) {
<div class="product-card">
    <div class="image-container" [ngClass]="imageBgClass">
        <img
            [src]="product.images.imagesUrl[0]"
            class="product-image"
            alt="Product Image"
            (click)="onClickProduct(product.id)"
        />
        @if (product.category.includes(productCategories.BestSeller)) {
        <span class="best-seller">BESTSELLER</span>
        } @else { @if (product.discountPercentage) {
        <span class="discount-percentage">{{ product.discountPercentage }}% OFF</span>
        } } @if (isWishlist) {
        <button
            mat-icon-button
            class="wishlist-button icon-button-overlay-remove"
            (click)="deleteWishlistItem(product)"
        >
            <mat-icon class="close-icon">close</mat-icon>
        </button>
        } @else {
        <button mat-icon-button class="wishlist-button icon-button-overlay-remove" (click)="toogleFavorite(product)">
            @if (isInWishlist(product)) {
            <mat-icon [svgIcon]="'activewishlist'" class="active-wish"></mat-icon>
            } @else {
            <mat-icon [svgIcon]="'wishlist'" class="wishlist-icon"></mat-icon>
            }
        </button>
        }
    </div>

    <div class="product-info">
        <p class="name font-poppins" appEllipsis maxWidth="220px">{{ product.name }}</p>
        <div class="rating">
            @if (product.averageRating) {
            <div class="rating-container">
                @if(product.averageRating! % 1 === 0) {
                <mat-icon svgIcon="fullstar" class="star-icon"></mat-icon>
                } @else {
                <mat-icon svgIcon="halfstar" class="star-icon"></mat-icon>
                }

                <span class="average-rating">{{ product.averageRating }}</span>
                <span class="reviews">({{ product.reviews!.length }} reviews)</span>
            </div>
            } @else {
            <div class="newarrival">
                <mat-icon svgIcon="newarrival" class="newarrival-icon"></mat-icon>
                New Arrival
            </div>
            }
        </div>
        @if (product.discountedPrice) {
        <div class="price-container">
            <p class="discounted-price">{{ product.discountedPrice | currency: "INR" }}</p>
            <p class="price">{{ product.price | currency: "INR" }}</p>
        </div>
        } @else {
        <div class="price-container">
            <p class="discounted-price">{{ product.price | currency: "INR" }}</p>
        </div>
        } @if (isWishlist) {
        <button mat-stroked-button class="add-to-cart-btn" (click)="moveToCart(product, 1)">Move to Cart</button>
        } @else { @if (getProductQtyInCart(product.id)) {
        <div class="quantity-container">
            <button
                class="quantity-button"
                [disabled]="getProductQtyInCart(product.id) <= 0"
                (click)="onclick(-1, product.id)"
            >
                <mat-icon [svgIcon]="'minus'" class="quantity-icon"></mat-icon>
            </button>
            <input
                type="number"
                class="quantity-input"
                [value]="getProductQtyInCart(product.id)"
                (input)="onInputChange($event, product.id)"
                (blur)="onBlur($event, product.id)"
                min="1"
                max="99"
            />
            <button
                class="quantity-button"
                [disabled]="getProductQtyInCart(product.id) >= 99"
                (click)="onclick(1, product.id)"
            >
                <mat-icon [svgIcon]="'plus'" class="quantity-icon"></mat-icon>
            </button>
        </div>
        } @else { @if (isCategoryBuyBlocks(product.category)) {
        <button mat-flat-button class="btn-primary-gradient" (click)="onCustomize(product.id)">Customize</button>
        } @else {
        <button mat-flat-button class="btn-primary-gradient" (click)="addToCart(product, 1)">Add to Cart</button>
        } } }
    </div>
</div>
}
